  class CollectionPage {
    constructor() {
      this.sortSelect = document.querySelector('.sort-select');
      this.accordionTriggers = document.querySelectorAll('[data-accordion-trigger]');
      this.viewToggleBtns = document.querySelectorAll('[data-view]');
      this.customRequestToggle = document.querySelector('[data-custom-request-toggle]');
      this.customRequestClose = document.querySelector('[data-custom-request-close]');
      this.customRequestForm = document.querySelector('[data-custom-request-form]');
      this.heroContent = document.querySelector('.collection-hero__content');

      this.init();
    }

    init() {
      this.bindEvents();
      this.initScrollAnimations();
      this.initAddToCart();
      this.initAccordion();
      this.initCustomRequestForm();
    }

    bindEvents() {
      // Sort functionality
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', (e) => this.handleSort(e));
      }

      // View toggle functionality
      this.viewToggleBtns.forEach(btn => {
        btn.addEventListener('click', (e) => this.handleViewToggle(e));
      });
    }

    initAccordion() {
      this.accordionTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
          const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
          trigger.setAttribute('aria-expanded', !isExpanded);
        });
      });
    }

    initCustomRequestForm() {
      if (!this.customRequestToggle || !this.heroContent) return;

      this.customRequestToggle.addEventListener('click', () => {
        this.openCustomRequestForm();
      });

      if (this.customRequestClose) {
        this.customRequestClose.addEventListener('click', () => {
          this.closeCustomRequestForm();
        });
      }

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.heroContent.classList.contains('form-active')) {
          this.closeCustomRequestForm();
        }
      });

      const form = this.customRequestForm?.querySelector('form');
      if (form) {
        form.addEventListener('submit', (e) => this.handleCustomRequestSubmit(e, form));
      }
    }

    openCustomRequestForm() {
      this.heroContent.classList.add('form-active');
      // Lock body scroll on mobile when form is open
      if (window.innerWidth <= 768) {
        document.body.style.overflow = 'hidden';
      }
      setTimeout(() => {
        const nameInput = document.getElementById('custom-request-name');
        if (nameInput) {
          nameInput.focus();
        }
      }, 550);
    }

    closeCustomRequestForm() {
      this.heroContent.classList.remove('form-active');
      // Restore body scroll
      document.body.style.overflow = '';
    }

    async handleCustomRequestSubmit(e, form) {
      e.preventDefault();

      const webhookUrl = form.dataset.webhookUrl;
      const webhookEnabled = form.dataset.webhookEnabled === 'true';

      if (!webhookEnabled || !webhookUrl) {
        console.error('Webhook is not configured. Enable it in the theme editor.');
        alert('Form submission is not configured. Please contact the site administrator.');
        return;
      }

      const submitBtn = form.querySelector('.custom-request-form__submit');
      const originalContent = submitBtn.innerHTML;

      submitBtn.classList.add('is-submitting');
      submitBtn.innerHTML = `
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <circle cx="12" cy="12" r="10"/>
        </svg>
        Sending...
      `;

      // Set timestamp
      const timestampField = form.querySelector('input[name="submitted_at"]');
      if (timestampField) {
        timestampField.value = new Date().toISOString();
      }

      const formData = new FormData(form);

      try {
        await fetch(webhookUrl, {
          method: 'POST',
          body: formData
        });

        if (typeof window.htsTrack === 'function') window.htsTrack('quote_submitted', 'collection_custom_request');
        this.showSuccessState();
      } catch (error) {
        console.error('Webhook error:', error);
        submitBtn.classList.remove('is-submitting');
        submitBtn.innerHTML = originalContent;
        alert('Sorry, there was an error submitting your request. Please try again.');
      }
    }

    showSuccessState() {
      const formContainer = this.customRequestForm;
      if (!formContainer) return;

      formContainer.innerHTML = `
        <button type="button" class="custom-request-form__close" data-custom-request-close aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
        <div class="custom-request-form__success">
          <div class="custom-request-form__success-icon">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="20,6 9,17 4,12"/>
            </svg>
          </div>
          <h3 class="custom-request-form__success-title">Request Submitted!</h3>
          <p class="custom-request-form__success-text">Thank you for your custom request. Our team will review it and get back to you shortly.</p>
        </div>
      `;

      const newCloseBtn = formContainer.querySelector('[data-custom-request-close]');
      if (newCloseBtn) {
        newCloseBtn.addEventListener('click', () => {
          this.closeCustomRequestForm();
          setTimeout(() => location.reload(), 300);
        });
      }
    }

    handleViewToggle(e) {
      const view = e.currentTarget.dataset.view;
      const grid = document.querySelector('[data-collection-grid]');

      // Update active state
      this.viewToggleBtns.forEach(btn => {
        btn.classList.remove('view-toggle-btn--active');
      });
      e.currentTarget.classList.add('view-toggle-btn--active');

      // Toggle list/grid view
      if (view === 'list') {
        grid.classList.add('collection-grid--list');
      } else {
        grid.classList.remove('collection-grid--list');
      }
    }

    initAddToCart() {
      // Handle add to cart forms
      document.querySelectorAll('.product-card__form').forEach(form => {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          await this.handleAddToCart(form);
        });
      });
    }

    async handleAddToCart(form) {
      const button = form.querySelector('[data-add-to-cart]');
      const formData = new FormData(form);

      // Set loading state
      button.classList.add('is-adding');
      button.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });

        if (!response.ok) {
          throw new Error('Failed to add to cart');
        }

        const data = await response.json();

        // Set success state
        button.classList.remove('is-adding');
        button.classList.add('is-added');

        // Reset button after 2 seconds
        setTimeout(() => {
          button.classList.remove('is-added');
          button.disabled = false;
        }, 2000);

        // Update cart count if cart icon exists
        this.updateCartCount();

      } catch (error) {
        console.error('Error adding to cart:', error);
        button.classList.remove('is-adding');
        button.disabled = false;
        alert('Sorry, there was an error adding this item to your cart. Please try again.');
      }
    }

    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // Update cart count in header if element exists
        const cartCountElements = document.querySelectorAll('[data-cart-count]');
        cartCountElements.forEach(el => {
          el.textContent = cart.item_count;
        });
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }

    handleSort(e) {
      const sortValue = e.target.value;
      // TODO: Implement actual sorting when connected to Shopify collections
      console.log('Sort by:', sortValue);

      // const url = new URL(window.location.href);
      // if (sortValue === 'manual') {
      //   url.searchParams.delete('sort_by');
      // } else {
      //   url.searchParams.set('sort_by', sortValue);
      // }
      // window.location.href = url.toString();
    }

    initScrollAnimations() {
      // Only animate if user hasn't set reduced motion preference
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      const cards = document.querySelectorAll('[data-product-card]');

      // Simple intersection observer for fade-in
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '0';
            entry.target.style.transform = 'translateY(30px)';

            setTimeout(() => {
              entry.target.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
              entry.target.style.opacity = '1';
              entry.target.style.transform = 'translateY(0)';
            }, 50);

            observer.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      cards.forEach((card, index) => {
        setTimeout(() => {
          observer.observe(card);
        }, index * 50);
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new CollectionPage());
  } else {
    new CollectionPage();
  }
